import { AvanoComboboxSingleComponent } from './avano-combobox-single.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvanoComboboxTemplateDirective } from './avano-combobox.common';

@NgModule({
  imports: [CommonModule],
  exports: [AvanoComboboxSingleComponent, AvanoComboboxTemplateDirective],
  declarations: [AvanoComboboxSingleComponent, AvanoComboboxTemplateDirective]
})
export class AvanoComboboxModule {}
